export default {
    baseStyle: {
        heading: {
            letterSpacing: '1.2px'
        },
        sizeGuideButton: {
            variant: 'textUnderline',
            display: 'inline-flex',
            alignItems: 'center',
            flexShrink: 0,
            gap: '5px',
            marginLeft: 'auto',
            padding: 0,
            minWidth: 'auto',
            minHeight: 'auto',
            height: 'auto',
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.07px',
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            color: 'black.100',
            whiteSpace: 'nowrap',
            fontWeight: '300',
            fontFamily: 'body'
        },
        sizeGuideIcon: {
            width: '16px',
            height: '16px'
        },
        content: {
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.07px',
            sx: {
                h3: {
                    fontSize: '14px',
                    lineHeight: '22px',
                    letterSpacing: '0.07px',
                    display: 'inline-block',
                    fontWeight: '400',
                    marginRight: '15px'
                },
                'h3 + p': {
                    fontSize: '14px',
                    lineHeight: '22px',
                    letterSpacing: '0.07px',
                    display: 'inline'
                },
                'br + h3, p + h3': {
                    marginTop: '10px'
                },
                a: {
                    textDecoration: 'underline',
                    _hover: {
                        color: 'blue.700'
                    }
                }
            }
        }
    }
}
